export var version = {
  lib: '2.7968.18',
  product: '2.7968.18',
  supportedApiVersion: 2
};



// WEBPACK FOOTER //
// ./src/misc/Version.ts